module.exports = __webpack_public_path__ + "static/media/content-2.0a55a9e7.svg";